import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useT } from "@/i18n";

const KEY = "kyt_cookie_consent";

export default function CookieConsent() {
  const t = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = window.localStorage.getItem(KEY);
    if (!seen) {
      const id = setTimeout(() => setShow(true), 900);
      return () => clearTimeout(id);
    }
  }, []);

  const accept = () => {
    window.localStorage.setItem(KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-50 animate-[kyt-fade-up_0.5s_ease]"
      data-testid="cookie-consent"
    >
      <div className="bg-navy-900/95 backdrop-blur-xl border border-white/10 rounded-2xl p-5 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.6)]">
        <div className="flex items-start gap-3.5">
          <span className="mt-0.5 h-9 w-9 grid place-items-center rounded-full bg-brand-blue/20 text-brand-electric shrink-0">
            <Cookie className="h-4.5 w-4.5" />
          </span>
          <div className="flex-1">
            <p className="text-[13.5px] leading-relaxed text-white/75 font-light">
              {t("cookie.text")}{" "}
              <Link to="/cerez-politikasi" data-testid="cookie-policy-link" className="text-brand-electric underline underline-offset-2 hover:text-white transition-colors">
                {t("cookie.policy")}
              </Link>
            </p>
            <div className="mt-4">
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="inline-flex items-center rounded-full bg-white text-navy px-6 py-2.5 text-[13px] font-semibold tracking-wide transition-colors hover:bg-brand-electric hover:text-white"
              >
                {t("cookie.accept")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
